if (!customElements.get('metafield-custom-variants')) {
  class MetafieldCustomVariants extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('.mcv-group-title').forEach((titleItem) => {
        titleItem.addEventListener('click', this.handleTitleClick.bind(this));
      });

      this.querySelectorAll('.js-mcv-back').forEach((backBtn) => {
        backBtn.addEventListener('click', this.handleBackClick.bind(this));
      });

      this.querySelectorAll('.mcv-group-swatch').forEach((swatchItem) => {
        swatchItem.addEventListener('click', this.handleSwatchClick.bind(this));
      });
    }

    handleTitleClick(evt) {
      let title = evt.target.closest('.mcv-group-title');
      let variantId = title.getAttribute('data-variant-id');
      // remove active class from all other titles
      this.querySelectorAll('.mcv-group-title').forEach((titleItem) => {
        if (titleItem !== title) {
          titleItem.classList.remove('active');
        }
      });
      if (!title.classList.contains('active')) {
        title.classList.add('active');
        // remove all active .mcv-group-swatch
        this.querySelectorAll('.mcv-group-swatch').forEach((swatchItem) => {
          swatchItem.classList.remove('active');
        });
        document.querySelector('.mcv-selected-swatch').innerHTML = '';
        document.querySelector('.js-mcv-swatch-input').value = '';
        document.querySelector('.js-mcv-addtocart').setAttribute('disabled', 'disabled');
      }
      document.querySelector('.mcv-selected-variant').innerHTML = title.querySelector('.mcv-variant-title').innerHTML;
      document.querySelector('.js-product-form-main input[name="id"]').value = variantId;

      this.querySelector('.mcv-group-title-wrapper').classList.add('hidden');
      if (this.querySelector(`.mcv-group-swatch-wrapper[data-variant-id="${variantId}"]`)) {
        // only show the one that matches the group title
        this.querySelectorAll('.mcv-group-swatch-wrapper').forEach((swatchItem) => {
          swatchItem.classList.add('hidden');
        });
        this.querySelector(`.mcv-group-swatch-wrapper[data-variant-id="${variantId}"]`).classList.remove('hidden');
      }
    }

    handleBackClick(evt) {
      // hide all .mcv-group-swatch-wrapper
      this.querySelectorAll('.mcv-group-swatch-wrapper').forEach((swatchItem) => {
        swatchItem.classList.add('hidden');
      });

      // show .mcv-group-title-wrapper
      this.querySelectorAll('.mcv-group-title-wrapper').forEach((titleItem) => {
        titleItem.classList.remove('hidden');
      });
    }

    handleSwatchClick(evt) {
      let swatch = evt.target.closest('.mcv-group-swatch');
      if (swatch) {
        // remove active class from all other swatches and add active on the clicked one
        this.querySelectorAll('.mcv-group-swatch').forEach((swatchItem) => {
          if (swatchItem !== swatch) {
            swatchItem.classList.remove('active');
          }
        });
        swatch.classList.add('active');
        document.querySelector('.mcv-selected-swatch').innerHTML = swatch.getAttribute('data-swatch');
        document.querySelector('.js-mcv-swatch-input').value = swatch.getAttribute('data-swatch');
        document.querySelector('.js-mcv-addtocart').removeAttribute('disabled');
      }
    }
  }

  customElements.define('metafield-custom-variants', MetafieldCustomVariants);
}

document.addEventListener('DOMContentLoaded', function () {
  // open metafield custom variants drawer
  document.addEventListener('click', function(e) {
    if (e.target.closest('.js-open-mcv-drawer')) {
      e.preventDefault();
      const drawer = document.querySelector('.js-custom-variants-drawer');
      if (drawer) {
        drawer.open();
      }
    }

    if (e.target.closest('.js-mcv-addtocart')) {
      e.preventDefault();
      const drawer = document.querySelector('.js-custom-variants-drawer');
      if (drawer) {
        drawer.close();
      }
      const form = document.querySelector('.js-product-form-main');
      if (form) {
        if (form.querySelector('.js-add-to-cart')) {
          form.querySelector('.js-add-to-cart').click();
        } else {
          form.submit();
        }
      }
    }

    if (e.target.closest('.product-info .js-add-to-cart')) {
      if (document.querySelector('.js-mcv-swatch-input') && document.querySelector('.js-mcv-swatch-input').value == '') {
        e.preventDefault();
        alert(window.theme.strings.metafieldCustomVariants.error);
        if (document.querySelector('.js-open-mcv-drawer')) {
          document.querySelector('.js-open-mcv-drawer').classList.add('error');
        }
      }
    }
  });
});